import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Config from '../../config/config';

const NotificationSound = ({ notificationCounter }) => {
    const audioRef = useRef();

    useEffect(() => {
        if (audioRef.current && notificationCounter > 0) {
            audioRef.current.play();
        }
    }, [notificationCounter]);

    return (
        <audio ref={audioRef}>
            <source src={Config.liveChatAudioNotificationSourceWav} type="audio/wav" />
        </audio>
    );
};
const mapStateToProps = state => {
    return {
        notificationCounter: state.liveChat.notificationCounter,
    };
};

export default connect(mapStateToProps, null)(NotificationSound);
